/**
 * The identifier for the data store.
 */
export const STORE_NAME = 'core/preferences';
